import { render, staticRenderFns } from "./sign-up-form.vue?vue&type=template&id=33f4b9fe&scoped=true"
import script from "./sign-up-form.vue?vue&type=script&lang=js"
export * from "./sign-up-form.vue?vue&type=script&lang=js"
import style0 from "./sign-up-form.vue?vue&type=style&index=0&id=33f4b9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4b9fe",
  null
  
)

export default component.exports